import { Model, attr } from '@elatonsev/js-models';

export default class CurrencyModel extends Model {
  sign = attr('string');
}